/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PipelineMapListGeometry } from './PipelineMapListGeometry';
import {
    PipelineMapListGeometryFromJSON,
    PipelineMapListGeometryFromJSONTyped,
    PipelineMapListGeometryToJSON,
    PipelineMapListGeometryToJSONTyped,
} from './PipelineMapListGeometry';

/**
 * Serializer used by map that returns the least amount of
 * information necessary to render the map.
 * @export
 * @interface PipelineMapList
 */
export interface PipelineMapList {
    /**
     * 
     * @type {string}
     * @memberof PipelineMapList
     */
    readonly id: string;
    /**
     * 
     * @type {PipelineMapListGeometry}
     * @memberof PipelineMapList
     */
    geometry?: PipelineMapListGeometry | null;
}

/**
 * Check if a given object implements the PipelineMapList interface.
 */
export function instanceOfPipelineMapList(value: object): value is PipelineMapList {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PipelineMapListFromJSON(json: any): PipelineMapList {
    return PipelineMapListFromJSONTyped(json, false);
}

export function PipelineMapListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PipelineMapList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'geometry': json['geometry'] === undefined ? undefined : json['geometry'] === null ? null : PipelineMapListGeometryFromJSON(json['geometry']),
    };
}

export function PipelineMapListToJSON(json: any): PipelineMapList {
    return PipelineMapListToJSONTyped(json, false);
}

export function PipelineMapListToJSONTyped(value?: Omit<PipelineMapList, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'geometry': PipelineMapListGeometryToJSON(value['geometry']),
    };
}

